import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.ISSUER_MENU;

export const IssuerMenuLinks: Array<LinkItemProps> = [
  {
    name: 'Presentation',
    link: URL.PRESENTATION_MENU.ROOT,
    level: 3,
    subMenu: [
      {
        name: "Consultation présentation",
        link: URL.PRESENTATION_MENU.PRESENTATION_CONSULTATION,
        level: 4,
      },
      {
        name: "Consultation représentation",
        link: URL.PRESENTATION_MENU.REPRESENTATION_CONSULTATION,
        level: 4,
      },
      {
        name: "Consultation annulation présentation",
        link: URL.PRESENTATION_MENU.PRESENTATION_CANCELLATION_CONSULTATION,
        level: 4,
      },
    ]
  },
  {
    name: 'Refacturation',
    link: URL.CHARGEBACK_MENU.ROOT,
    level: 3,
    subMenu: [
      {
        name: "Création",
        link: URL.CHARGEBACK_MENU.CREATION,
        level: 4,
      },
      {
        name: "Avant Contrôle Traitement",
        link: URL.CHARGEBACK_MENU.PRE_CONTROL_TREATMENT,
        level: 4,
      },
      {
        name: "Consultation",
        link: URL.CHARGEBACK_MENU.CONSULTATION,
        level: 4,
      },
      {
        name: "Retraitement operation",
        link: URL.CHARGEBACK_MENU.REPROCESSING_OPERATION,
        level: 4,
      },
      {
        name: "Annulation",
        link: URL.CHARGEBACK_MENU.CANCELLATION_MENU.ROOT,
        level: 4,
        subMenu: [
          {
            name: "Création",
            link: URL.CHARGEBACK_MENU.CANCELLATION_MENU.CREATION,
            level: 5,
          },
          {
            name: "Avant Contrôle Traitement",
            link: URL.CHARGEBACK_MENU.CANCELLATION_MENU.PRE_CONTROL_TREATMENT,
            level: 5,
          },
          {
            name: "Consultation",
            link: URL.CHARGEBACK_MENU.CANCELLATION_MENU.CONSULTATION,
            level: 5,
          },
          {
            name: "Retraitement operation",
            link: URL.CHARGEBACK_MENU.CANCELLATION_MENU.REPROCESSING_OPERATION,
            level: 5,
          },
        ]
      },
    ]
  },
  {
    name: 'Demande',
    link: URL.REQUEST_MENU.ROOT,
    level: 3,
    subMenu: [
      {
        name: "Création",
        link: URL.REQUEST_MENU.CREATION,
        level: 4,
      },
      {
        name: "Avant Contrôle Traitement",
        link: URL.REQUEST_MENU.PRE_CONTROL_TREATMENT,
        level: 4,
      },
      {
        name: "Consultation",
        link: URL.REQUEST_MENU.CONSULTATION,
        level: 4,
      },
      {
        name: "Retraitement operation",
        link: URL.REQUEST_MENU.REPROCESSING_OPERATION,
        level: 4,
      },
    ]
  },
  {
    name: 'Consultation confirmation demande',
    link: URL.CONSULTING_CONFIRMATION_REQUEST,
    level: 3,
  },
  
];

